import { useTranslation } from 'react-i18next'
import Collapse from '@mui/material/Collapse'
import { KeyboardArrowDown, KeyboardArrowUp, LockOutlined } from '@mui/icons-material'
import Title from '@/components/_custom/Title/title'
import ButtonTextIcon from '@/components/_custom/Buttons/ButtonTextIcon/ButtonTextIcon'
import DialogActions from '@/components/_custom/DialogActions/DialogActions'
import { useDaycareRight } from '@/hooks/useDaycareRight'
import { useOccasionalSlotForm } from './hooks/useOccasionalSlotForm'
import { OccasionalSlotFormProps } from './types'
import OccasionalSlotFields from './components/OccasionalSlotFields/occasionalSlotFields'
import styles from './occasionalSlotForm.module.scss'

export type { OccasionalSlotFormCommonProps, EditBaseProps, OccasionalSlotFormProps } from './types'

function OccasionalSlotForm(props: OccasionalSlotFormProps) {
    const canWrite: boolean = useDaycareRight('canWriteOccasionalSlot')
    return canWrite ? <OccasionalSlotFormContent {...props} /> : null
}

function OccasionalSlotFormContent(props: OccasionalSlotFormProps) {
    const { t } = useTranslation()
    const { type, handleClose, calendarEvents, places } = props
    const form: ReturnType<typeof useOccasionalSlotForm> = useOccasionalSlotForm(props)

    return (
        <div key={form.validationAttempt}>
            <div className={styles.Grid}>
                <OccasionalSlotFields
                    form={form}
                    lines={form.layout.lines}
                    calendarEvents={calendarEvents}
                    places={places}
                />
                <div className={styles.MoreInfoContainer} onClick={() => form.setShowMore(!form.showMore)}>
                    <Title text={t('moreOptions')} className={styles.Title} />
                    {form.showMore ? (
                        <KeyboardArrowUp className={styles.Icon} />
                    ) : (
                        <KeyboardArrowDown className={styles.Icon} />
                    )}
                </div>
                <Collapse in={form.showMore} className={styles.MoreOptions}>
                    <div className={styles.Grid}>
                        <OccasionalSlotFields
                            form={form}
                            lines={form.layout.moreLines}
                            calendarEvents={calendarEvents}
                            places={places}
                        />
                    </div>
                </Collapse>
                <DialogActions className={styles.ButtonContainer}>
                    <ButtonTextIcon type={'close'} onClick={handleClose} className={styles.Button} nowrap />
                    {type === 'add' && form.confirmedChildIds.length !== form.occasionalSlotNumber && (
                        <ButtonTextIcon
                            type={'custom'}
                            onClick={() => form.handleConfirm(true)}
                            customIcon={<LockOutlined />}
                            customText={t('scheduled')}
                            className={styles.Button}
                            nowrap
                        />
                    )}
                    <ButtonTextIcon
                        type={type === 'add' ? 'add' : 'edit'}
                        onClick={form.handleFormConfirm}
                        className={styles.Button}
                        nowrap
                    />
                </DialogActions>
            </div>
            {form.scheduleDialog}
            {form.confirmationDialog}
        </div>
    )
}

export default OccasionalSlotForm
